import { connect } from 'react-redux';
import { omit } from 'lodash/fp';
import SearchContext from '../../../constants/reservation/SearchContext';
import { getIsFetching } from '../../../redux/Reservation/selectors/archived';
import { getPaginationQueryOptions } from '../../../redux/Reservation/selectors/archived/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Reservation/actions/components/search';
import { clearReservationArchived } from '../../../redux/Reservation/actions/archived';
import { fetchReservationArchived } from '../../../redux/Reservation/sagas/routines';
import ReservationSearch from '../../../components/reservations/Search';
import {
  setReservationsSearchQueryCookie,
  getReservationsSearchQueryCookie,
  getReservationsRememberFlagCookie
} from '../../../services/currentUserCookie';

const context = SearchContext.ARCHIVED;

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, context);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      const queryCookie = getReservationsSearchQueryCookie(context);
      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie && queryCookie) {
        const searchQuery = omit(['order', 'limit', 'page'], queryCookie);
        dispatch(onChangeQuery({ context, query: searchQuery }));
      }
    },
    onSubmit: queryOptions => {
      dispatch(clearReservationArchived());
      dispatch(fetchReservationArchived(queryOptions));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, queryOptions);
      }
    },
    onChange: searchQuery => {
      dispatch(onChangeQuery({ context, query: searchQuery }));
    },
    onClear: (includeCookie = true) => {
      dispatch(onClearQuery({ context }));
      dispatch(clearReservationArchived());
      dispatch(fetchReservationArchived({}));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (includeCookie && isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, {});
      }
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationSearch);
